import { type FC, memo } from 'react'
import styled from 'styled-components'

import InputHeaderRow from 'components/Input/InputHeaderRow'
import NumericInput from 'components/Input/NumericInput'
import Select from 'components/Select'
import { Body } from 'components/Text'
import { FlexDivCentered, FlexDivCol } from 'components/layout/flex'
import type { SLTPInputFieldProps } from '../Trade/SLTPInputField'

const EditStopLossAndTakeProfitInput: FC<SLTPInputFieldProps> = memo(
	({ type, size, value, invalidLabel, ...props }) => {
		return (
			<div style={{ marginTop: '5px', marginBottom: '10px' }}>
				<StyledInputHeaderRow
					label={type === 'take-profit' ? 'Take-profit Settings' : 'Stop-loss Settings'}
				/>
				<FlexDivCol rowGap="8px">
					<NumericInput
						data-testid={props.dataTestId}
						invalid={!!invalidLabel}
						right={
							<>
								{invalidLabel && <InvalidLabel color="negative">{invalidLabel}</InvalidLabel>}
								<Body color="secondary">USD</Body>
								<StyledLabelContainer>
									<Body size="large">Last</Body>
								</StyledLabelContainer>
							</>
						}
						value={value}
						placeholder="0.00"
						height={48}
						onChange={props.onChange}
					/>
				</FlexDivCol>
			</div>
		)
	}
)

const StyledInputHeaderRow = styled(InputHeaderRow)`
	margin-bottom: 9px;
`

export const StyledSelect = styled(Select)`
	width: 88px;
	z-index: 100;
	.react-select__control {
		border-right: none;
		border-top: none;
		border-bottom: none;
		border-radius: 0;
		padding: 5.5px 2px;
		background-color: transparent;
	}

	.react-select__menu {
		z-index: 10;
		width: 100%;
		background-color: ${(props) =>
			props.theme.colors.selectedTheme.newTheme.containers.secondary.background};
	}
`

const StyledLabelContainer = styled(FlexDivCentered)`
	height: 100%;
	padding-right: 10px;
	padding-left: 10px;
	margin-left: 10px;
	border-left: ${(props) => props.theme.colors.selectedTheme.border};

`

const InvalidLabel = styled(Body)`
	margin-right: 4px;
`

export default EditStopLossAndTakeProfitInput
